export enum QuizEditorSidebarTabs {
  Question = 'question',
  Design = 'design',
  Settings = 'settings',
}

export interface QuizEditorSidebarProps {
  tab?: string | null;
}
